import React from 'react';
// --- UI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// --- JS
import { NavLink } from 'react-router-dom';
import { routes } from '../shared/routes';

export const Header: React.FC = () => {

	return (
		<Box 
			position='fixed' 
			left={0} 
			right={0} 
			zIndex={999}
			bgcolor='white'
			boxShadow='0 2px 2px -2px gray'>
			<Box
				height='50px'
				maxWidth='1240px'
				margin='0 auto'

				display='flex'
				alignItems='center'
				justifyContent='space-between'>

				<NavLink to={routes.welcome}>
					<Typography fontWeight='700' variant='h6' color='black'> ASEND DEV </Typography>
				</NavLink>

				<Box display='flex' gap='24px'>
					<NavLink to={routes.documentation}>
						<Typography variant='subtitle1' fontWeight='500' color='black'> Documentation </Typography>
					</NavLink>
				</Box>

			</Box>

		</Box>
	);
};